import { useSelector } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

import { emailRegex } from 'constants/regex';
import { componentsSize, HEADER_HEIGHT, SIDEBAR_WIDTH } from 'constants/components';
import { useInviteUsers } from 'hooks/useInviteUsers';
import { useMatchPathParams } from 'hooks/useMatchPathParams';
import { dialogPropsSelector } from 'store/entities/ui/slice';
import { RadioGroup } from 'components/complex/RadioGroup';
import ListInput from 'components/complex/ListInput';
import { ButtonCloseDialog } from 'components/simple';

const styles = {
  radioLabel: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  dialogPaper: {
    maxWidth: 1100,
    margin: 'unset',
    position: 'absolute',
    top: HEADER_HEIGHT + 60,
    left: SIDEBAR_WIDTH + 20,
    borderRadius: '38px',
    paddingBlock: 3,
    paddingInline: 2,
  },
  dialogContent: { paddingBottom: 1, overflow: 'visible' },
  dialogActions: {
    paddingBottom: 2,
    paddingRight: 3,
    paddingTop: 0,
    paddingLeft: 0,
  },
};

const validateEmail = (email) => emailRegex.test(email);

export const AddUserDialog = () => {
  const { toggleAddUsersPopup } = useSelector(dialogPropsSelector);
  const { organisationId } = useMatchPathParams();
  const {
    isLoading,
    permissionsOptions,
    emailsList,
    inviteUsers,
    setEmailsList,
    selectedPermission,
    setSelectedPermission,
  } = useInviteUsers(organisationId);

  const handleSubmitInvite = async () => {
    await inviteUsers();
    toggleAddUsersPopup();
  };

  return (
    <Dialog
      fullWidth
      open
      onClose={isLoading ? undefined : toggleAddUsersPopup}
      slotProps={{ paper: { sx: styles.dialogPaper } }}
    >
      <DialogTitle variant="h2-bold" display="flex" justifyContent="space-between" alignItems="center">
        Add Users
        <ButtonCloseDialog onClick={toggleAddUsersPopup} disabled={isLoading} />
      </DialogTitle>

      <DialogContent sx={styles.dialogContent}>
        <Stack spacing={3}>
          <Typography variant="button" component="p" textAlign="left">
            Invite with email
          </Typography>

          <ListInput
            values={emailsList}
            placeholder="Enter one or more email addresses"
            validate={validateEmail}
            onChange={setEmailsList}
            id="add-user-dialog-input"
          />

          <RadioGroup options={permissionsOptions} value={selectedPermission} onChange={setSelectedPermission} />
        </Stack>
      </DialogContent>

      <DialogActions sx={styles.dialogActions}>
        <Button
          loading={isLoading}
          disabled={!emailsList.length}
          onClick={handleSubmitInvite}
          size={componentsSize.small}
          id="add-user-dialog-button"
        >
          Invite
        </Button>
      </DialogActions>
    </Dialog>
  );
};
